const GTM_ID = import.meta.env.VITE_GTM_ID || 'GTM-NHP4GV2V'

export const initGTM = () => {
  if (!GTM_ID || typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.__temporizaGtmInitialized) return

  const alreadyLoaded = document.querySelector(
    `script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`
  )
  if (alreadyLoaded) {
    window.__temporizaGtmInitialized = true
    return
  }

  window.__temporizaGtmInitialized = true
  window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : []
  try {
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    })
  } catch {
    // Never break app boot because of analytics
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
  document.head.appendChild(script)
}

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined') return false
  try {
    window.dataLayer = Array.isArray(window.dataLayer) ? window.dataLayer : []
    window.dataLayer.push({ event: eventName, ...params })
    return true
  } catch {
    return false
  }
}
